<template>
    <BasicDialog>
        
        <div class="install-instructions">
            <p class="instruction-title">Follow these steps to install:</p>
            
            <ol class="steps-list">
                <li>Tap the <strong>Share</strong> button <v-img :src="'/assets/AppleShare.svg'" style="width: 25px; height: 25px; display: inline-block;"></v-img> in the browser</li>
                <li v-if="isMacSafari">Scroll down and tap <strong>Add to Dock</strong> <v-img :src="'/assets/AppleAddToHome.svg'" style="width: 22px; height: 22px; display: inline-block;"></v-img></li>
                <li v-else>Scroll down and tap <strong>Add to Home Screen</strong> <v-img :src="'/assets/AppleAddToHome.svg'" style="width: 22px; height: 22px; display: inline-block;"></v-img></li>
                <li>Tap <strong>Add</strong> in the top right corner</li>
            </ol>
            
            <p class="note">{{ isMacSafari ? 'The app will then be installed in your Dock for quick access!' : 'The app will then be installed on your home screen for quick access!' }}</p>
        </div>
    </BasicDialog>
</template>

<script setup lang="ts">
import BasicDialog from '@/components/Common/Basic-Dialog.vue';

interface Props {
    deviceInfo: {
        os_name: string;
        browser_name: string;
    } | null;
    isMacSafari: boolean;
}

defineProps<Props>();
</script>

<style scoped>
.install-instructions {
    padding: 16px;
    font-size: 1rem;
    line-height: 1.5;
}

.instruction-title {
    font-weight: 600;
    margin-bottom: 16px;
}

.steps-list {
    margin: 16px 0;
    padding-left: 24px;
}

.steps-list li {
    margin-bottom: 12px;
}

.icon {
    font-family: -apple-system;
    margin: 0 4px;
}

.note {
    color: #666;
    font-size: 0.9rem;
    margin-top: 16px;
}
</style>
